import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

import { STEP } from "../consts";
import { LoggedOutContactUsContext } from "../types";

const INITIAL_STATE: LoggedOutContactUsContext = {
  user: "",
  issueL1: "",
  issueL2: "",
  issueL3: "",
  currentStep: STEP.LOGGED_OUT_SELECT_TOPIC,
};

const {
  useStore: useLoggedOutContactUsContextStore,
  Provider: LoggedOutContactUsContextProvider,
} = createContextStore<LoggedOutContactUsContext>(INITIAL_STATE);

export { LoggedOutContactUsContextProvider, useLoggedOutContactUsContextStore };
